import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './auth-config.js';

// Un solo proveedor envuelve la app. Antes esto era Amplify.configure repetido
// en cuatro modulos; ahora la sesion vive en un contexto de React y los
// componentes la leen con useAuth().
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// El service worker precachea el bundle y, por defecto, el nuevo se queda en
// espera hasta que se cierran TODAS las pestañas del sitio. Resultado: tras un
// deploy la gente seguía ejecutando el JS viejo sin enterarse, y un Ctrl+F5 no
// alcanzaba. Aquí le pedimos que tome el control en cuanto esté listo.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

// A proposito NO se recarga la pagina al cambiar de worker. Se intento y fue
// peor: el reload llegaba a media alta —despues de pedir el codigo, antes de
// confirmarlo— y se perdia el paso en el que ibas. Con skipWaiting basta: el
// worker nuevo queda activo y el bundle actualizado entra en la siguiente
// carga, sin tirar lo que el usuario tenga a medias.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
